// extracted by css-extract-rspack-plugin
export default {"root":"root-b23j0Z"};